import React from 'react';
import { useApplication } from '../../context/ApplicationContext';
import FormField from '../FormField';
import SelectField from '../SelectField';

function ContactInfoStep() {
  const { state, dispatch } = useApplication();
  const { formData } = state;

  const handleChange = (field, value) => {
    dispatch({
      type: 'UPDATE_FORM_DATA',
      payload: { [field]: value }
    });
  };

  const regionOptions = [
    { value: 'greater-accra', label: 'Greater Accra' },
    { value: 'ashanti', label: 'Ashanti' },
    { value: 'western', label: 'Western' },
    { value: 'central', label: 'Central' },
    { value: 'eastern', label: 'Eastern' },
    { value: 'volta', label: 'Volta' },
    { value: 'northern', label: 'Northern' },
    { value: 'upper-east', label: 'Upper East' },
    { value: 'upper-west', label: 'Upper West' },
    { value: 'brong-ahafo', label: 'Brong Ahafo' },
  ];

  return (
    <div className="space-y-6 w-full max-w-full overflow-x-hidden">
      <FormField
        label="Residential Address"
        type="textarea"
        value={formData.residentialAddress}
        onChange={(value) => handleChange('residentialAddress', value)}
        required
        rows={3}
        placeholder="Enter your complete residential address"
        fieldName="residentialAddress"
      />

      <FormField
        label="Postal Address"
        type="textarea"
        value={formData.postalAddress}
        onChange={(value) => handleChange('postalAddress', value)}
        rows={3}
        placeholder="P.O. Box or postal address (if different from residential)"
        fieldName="postalAddress"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <FormField
          label="City/Town"
          type="text"
          value={formData.city}
          onChange={(value) => handleChange('city', value)}
          required
          fieldName="city"
        />
        <SelectField
          label="Region"
          value={formData.region}
          onChange={(value) => handleChange('region', value)}
          options={regionOptions}
          required
          fieldName="region"
        />
      </div>

      <FormField
        label="Country"
        type="text"
        value={formData.country}
        onChange={(value) => handleChange('country', value)}
        required
        disabled
        fieldName="country"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <FormField
          label="Primary Phone Number"
          type="tel"
          value={formData.phoneNumber}
          onChange={(value) => handleChange('phoneNumber', value)}
          required
          placeholder="+233 XX XXX XXXX"
          fieldName="phoneNumber"
        />
        <FormField
          label="Alternate Phone Number"
          type="tel"
          value={formData.alternatePhone}
          onChange={(value) => handleChange('alternatePhone', value)}
          placeholder="+233 XX XXX XXXX"
          fieldName="alternatePhone"
        />
      </div>

      <FormField
        label="Email Address"
        type="email"
        value={formData.email}
        onChange={(value) => handleChange('email', value)}
        required
        placeholder="your.email@example.com"
        fieldName="email"
      />

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 w-full">
        <h4 className="font-medium text-blue-900 mb-2">Contact Information Notice</h4>
        <p className="text-sm text-blue-800">
          This contact information will be used for all bank communications, including account statements, notifications, and important updates. Please ensure all details are accurate and up-to-date.
        </p>
      </div>
    </div>
  );
}

export default ContactInfoStep;